import { Enum } from 'enumify';

export default class TipoMotoboyEnum extends Enum {}

// Tipos de Entrega Motoboy
TipoMotoboyEnum.initEnum({
    PROGRAMADA: {
        get buildEntregaLabel() { return "ENTREGA PROGRAMADA" },
    },
    RAPIDA: {
        get buildEntregaLabel() { return "ENTREGA RÁPIDA" },
    },
    RETIRADA_BALCAO: {
        get buildEntregaLabel() { return "RETIRADA NA LOJA" },
    },
    LOCKER: {
        get buildEntregaLabel() { return "RETIRAR NO LOCKER PANVEL" },
    },
});


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/pages/checkout/entrega/tipo-motoboy.enum.js